import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=1b0d2d3c"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0d2d3c')) {
      api.createRecord('1b0d2d3c', component.options)
    } else {
      api.reload('1b0d2d3c', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=1b0d2d3c", function () {
      api.rerender('1b0d2d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/auth/ForgotPassword.vue"
export default component.exports